// @ vendor
const Immutable = require('immutable');

// @ constants
const {
    FLOW_STEPS,
    SPECIAL_COVERAGES_MODAL: {
        DOGS_INCLUSION_NO,
        DOGS_INCLUSION_YES,
        DOGS_INCLUSION,
        CIVIL_RESPONSABILITY_OPTIONS
    },
    COVERAGES
} = require('../../insuranceConstants/insuranceRequestHome');

const {
    INSURANCE_REQUEST_WIZARD_VALIDATE_STEP,
    INSURANCE_REQUEST_WIZARD_LOAD_STEP,
    INSURANCE_REQUEST_WIZARD_SET_VISIBLE_STEP,
    INSURANCE_REQUEST_COVERAGES_QUOTATION_REQUEST,
    INSURANCE_REQUEST_COVERAGES_QUOTATION_SUCCESS,
    INSURANCE_REQUEST_COVERAGES_QUOTATION_FAILURE,
    INSURANCE_REQUEST_GET_COVERAGES_AND_PLANS_TABLE_REQUEST,
    INSURANCE_REQUEST_GET_COVERAGES_AND_PLANS_TABLE_SUCCESS,
    INSURANCE_REQUEST_GET_COVERAGES_AND_PLANS_TABLE_FAILURE,
    INSURANCE_REQUEST_COVERAGES_DETAIL_BASIC_DATA_REQUEST,
    INSURANCE_REQUEST_COVERAGES_DETAIL_BASIC_DATA_SUCCESS,
    INSURANCE_REQUEST_COVERAGES_DETAIL_MEDIUM_DATA_REQUEST,
    INSURANCE_REQUEST_COVERAGES_DETAIL_MEDIUM_DATA_SUCCESS,
    INSURANCE_REQUEST_COVERAGES_DETAIL_HIGH_DATA_REQUEST,
    INSURANCE_REQUEST_COVERAGES_DETAIL_HIGH_DATA_SUCCESS,
    INSURANCE_REQUEST_COVERAGES_DETAIL_DATA_FAILURE,
    INSURANCE_REQUEST_SELECT_BASIC_PLAN,
    INSURANCE_REQUEST_SELECT_PLAN_REQUEST,
    INSURANCE_REQUEST_SELECT_PLAN_SUCCESS,
    INSURANCE_REQUEST_SELECT_PLAN_FAILURE,
    INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_REQUEST,
    INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_SUCCESS,
    INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_FAILURE,
    INSURANCE_REQUEST_CANCEL_SIMULATION_REQUEST,
    INSURANCE_REQUEST_CANCEL_SIMULATION_SUCCESS,
    INSURANCE_REQUEST_CANCEL_SIMULATION_FAILURE,
    INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_INITIAL_VALUE_IN_SUCCESS,
    INSURANCE_REQUEST_WIZARD_SET_DATA,
} = require('../../insuranceConstants/actionTypes');

const setInitialState = () => {
    return Immutable.Map().merge({
        valid: false,
        isFetchingCoverages: false,
        coveragesAndPlansData: {},
        isFetchingDetailsMedium: false,
        isFetchingDetailsBasic: false,
        isFetchingDetailsHigh: false,
        isFetchingQuotation: false,
        isQuotationDataChanged: false,
        quotationData: {},
        quotationDataDefault: {},
        coveragesDetailsBasicData: {},
        coveragesDetailsMediumData: {},
        coveragesDetailsHighData: {},
        coveragePlanDefault: {},
        coveragePlanModal: {},
        errorDetails: '',
        insurancePlan: '',
        basicPlanModalValidation: false,
        validUI: false,
        error: '',
        errorQuotation: '',
        isFetchingSelectPlan: false,
        errorSelectPlan: '',
        isLinkingInProgress: false,
        islinkingSuccess: false,
        linkingError: '',
        cancelInProgress: '',
        cancelError: '',
        fieldErrors: false,
        step3LoadingFromDetailsTable: false,
    });
};

const validateStep = step => {
    const insurancePlan = step.get('insurancePlan');
    const isFetchingQuotation = step.get('isFetchingQuotation') || step.get('quotationData').isEmpty();
    const isFetchingSelectPlan = step.get('isFetchingSelectPlan');
    const isFetchingCoverages = step.get('isFetchingCoverages') || step.get('coveragesAndPlansData').isEmpty();
    const isFetching = isFetchingQuotation || isFetchingSelectPlan || isFetchingCoverages

    return step.merge({
        valid: false,
        validUI: insurancePlan !== '' && !isFetching,
        fieldErrors: true
    });
};

const getDataCoveragePlan = dataCoverage => {
    const coveragePlan = {};

    dataCoverage.forEach(data => {
        coveragePlan[data.name] = {
            baseValue: data.defaultValue,
            changed: data.changed,
            currentValue: null,
            defaultValue: data.changed ? data.value : data.defaultValue,
            hasChanged: false,
            name: data.name,
            visible: data.visible
        }

        if (data.children) {
            const dataChildren = data.children;

            dataChildren.forEach(children => {
                coveragePlan[children.name] = {
                    baseValue: children.defaultValue,
                    changed: children.changed,
                    currentValue: null,
                    defaultValue: children.changed ? children.value : children.defaultValue,
                    hasChanged: false,
                    name: children.name,
                    visible: children.visible
                }
            });
        }
    });

    const dangerousDogsNumber = coveragePlan[COVERAGES.DANGEROUS_DOGS_NUMBER];

    if (!!dangerousDogsNumber) {
        coveragePlan[COVERAGES.DANGEROUS_DOGS_NUMBER].defaultValue = parseInt(dangerousDogsNumber.defaultValue) === 0 ? '' : dangerousDogsNumber.defaultValue;
        coveragePlan[COVERAGES.CIVIL_LIABILITY].defaultValue = CIVIL_RESPONSABILITY_OPTIONS[coveragePlan[COVERAGES.CIVIL_LIABILITY].defaultValue].value;
        coveragePlan[DOGS_INCLUSION] = {
            currentValue: null,
            defaultValue: parseInt(dangerousDogsNumber.defaultValue) > 0 ? DOGS_INCLUSION_YES : DOGS_INCLUSION_NO,
            hasChanged: false,
            name: DOGS_INCLUSION
        };
    }

    return coveragePlan;
}

const getCoveragePlanModal = data => {
    const coveragePlanModal = {};

    for (const prop in data) {
        coveragePlanModal[prop] = getDataCoveragePlan(data[prop]);
    }

    return coveragePlanModal;
}

const insuranceRequestWizardStep3 = (state = setInitialState(), action) => {
    switch (action.type) {
        case INSURANCE_REQUEST_WIZARD_VALIDATE_STEP:
            return validateStep(state);

        case INSURANCE_REQUEST_WIZARD_LOAD_STEP:
            return state.merge({
                insurancePlan: action.data.insurancePlan,
                valid: FLOW_STEPS[action.data.flowData.uiStep] > FLOW_STEPS.STEP_3
            });

        case INSURANCE_REQUEST_WIZARD_SET_VISIBLE_STEP:
            return state.merge({
                valid: false,
                fieldErrors: false,
                errorDetails: ''
            });

        case INSURANCE_REQUEST_GET_COVERAGES_AND_PLANS_TABLE_REQUEST:
            return state.merge({
                isFetchingCoverages: true,
                fieldErrors: false,
                error: ''
            });

        case INSURANCE_REQUEST_GET_COVERAGES_AND_PLANS_TABLE_SUCCESS:
            return state.mergeDeep({
                isFetchingCoverages: false,
                coveragesAndPlansData: action.data,
                coveragePlanModal: getCoveragePlanModal(action.data)
            });

        case INSURANCE_REQUEST_GET_COVERAGES_AND_PLANS_TABLE_FAILURE:
            return state.merge({
                isFetchingCoverages: false,
                error: action.data.error
            });

        case INSURANCE_REQUEST_COVERAGES_QUOTATION_REQUEST:
            return state.merge({
                isFetchingQuotation: true,
                errorQuotation: ''
            });

        case INSURANCE_REQUEST_COVERAGES_QUOTATION_SUCCESS:
            return state.merge({
                isFetchingQuotation: false,
                quotationData: action.data
            });

        case INSURANCE_REQUEST_COVERAGES_QUOTATION_FAILURE:
            return state.merge({
                isFetchingQuotation: false,
                errorQuotation: action.data.error
            });

        case INSURANCE_REQUEST_COVERAGES_DETAIL_MEDIUM_DATA_REQUEST:
            return state.merge({
                isFetchingDetailsMedium: true
            });

        case INSURANCE_REQUEST_COVERAGES_DETAIL_MEDIUM_DATA_SUCCESS:
            return state.merge({
                isFetchingDetailsMedium: false,
                coveragesDetailsMediumData: action.data
            });

        case INSURANCE_REQUEST_COVERAGES_DETAIL_BASIC_DATA_REQUEST:
            return state.merge({
                isFetchingDetailsBasic: true
            });

        case INSURANCE_REQUEST_COVERAGES_DETAIL_BASIC_DATA_SUCCESS:
            return state.merge({
                isFetchingDetailsBasic: false,
                coveragesDetailsBasicData: action.data
            });

        case INSURANCE_REQUEST_COVERAGES_DETAIL_HIGH_DATA_REQUEST:
            return state.merge({
                isFetchingDetailsHigh: true
            });

        case INSURANCE_REQUEST_COVERAGES_DETAIL_HIGH_DATA_SUCCESS:
            return state.merge({
                isFetchingDetailsHigh: false,
                coveragesDetailsHighData: action.data
            });

        case INSURANCE_REQUEST_COVERAGES_DETAIL_DATA_FAILURE:
            return state.merge({
                isFetchingDetailsHigh: false,
                errorDetails: action.data.error
            });
        case INSURANCE_REQUEST_SELECT_BASIC_PLAN:
            return state.merge({
                basicPlanModalValidation: true,
            })
        case INSURANCE_REQUEST_SELECT_PLAN_REQUEST:
            return state.merge({
                isFetchingSelectPlan: true
            });
        case INSURANCE_REQUEST_SELECT_PLAN_SUCCESS:
            return state.merge({
                isFetchingSelectPlan: false,
                insurancePlan: action.data.plan
            });
        case INSURANCE_REQUEST_SELECT_PLAN_FAILURE:
            return state.merge({
                isFetchingSelectPlan: false,
                errorSelectPlan: action.data.error
            });
        case INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_REQUEST:
            return state.merge({
                isLinkingInProgress: true,
                linkingError: '',
            });
        case INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_SUCCESS:
            return state.merge({
                isLinkingInProgress: false,
                islinkingSuccess: true,
                valid: true
            });
        case INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_FAILURE:
            return state.merge({
                isLinkingInProgress: false,
                linkingError: action.data.error
            });

        case INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_INITIAL_VALUE_IN_SUCCESS:
            return state.merge({
                islinkingSuccess: false,
            });

        case INSURANCE_REQUEST_CANCEL_SIMULATION_REQUEST:
            return state.merge({
                cancelInProgress: true
            });
        case INSURANCE_REQUEST_CANCEL_SIMULATION_SUCCESS:
            return state.merge({
                cancelInProgress: false
            });
        case INSURANCE_REQUEST_CANCEL_SIMULATION_FAILURE:
            return state.merge({
                cancelInProgress: false,
                cancelError: action.data.error
            });
        case INSURANCE_REQUEST_WIZARD_SET_DATA:
            return state.mergeDeep({
                ...action.data,
            });

        default:
            return state;
    }
};

module.exports = insuranceRequestWizardStep3;
